const DEFAULT_FLYO_API_BASE_URL = 'https://prod-api.flyo.ai';

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

export const FLYO_API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_FLYO_API_BASE_URL || DEFAULT_FLYO_API_BASE_URL
);

export const ADMIN_API_BASE_URL = `${FLYO_API_BASE_URL}/core/v1/admin`;
export const BUSINESS4FLYO_ADMIN_API_BASE_URL = `${FLYO_API_BASE_URL}/core/v1/businessFlyo/admin`;
export const FLYO4BUSINESS_ADMIN_API_BASE_URL = `${FLYO_API_BASE_URL}/flyo4business/admin`;
export const TRIP_API_BASE_URL = `${FLYO_API_BASE_URL}/core/v1/trip`;
export const INTERNAL_API_V1_BASE_URL = `${FLYO_API_BASE_URL}/core/v1/internal`;
export const INTERNAL_API_V2_BASE_URL = `${FLYO_API_BASE_URL}/core/v2/internal`;
